export default ({ request }) => ({
  ecomEvgExpenseListApi(data = {}) {
    return request({
      url: '/ecom/evg/expense/list',
      method: 'POST',
      data,
    })
  },
  ecomEvgExpenseSaveApi(data = {}) {
    return request({
      url: '/ecom/evg/expense/save',
      method: 'POST',
      data,
    })
  },
  ecomEvgExpenseDetailApi(data = {}) {
    return request({
      url: '/ecom/evg/expense/detail',
      method: 'POST',
      data,
    })
  },
  ecomEvgExpenseDocListApi(data = {}) {
    return request({
      url: '/ecom/evg/expense/doc/list',
      method: 'POST',
      data,
    })
  },
  ecomEvgExpenseItemListApi(data = {}) {
    return request({
      url: '/ecom/evg/expense/item/list',
      method: 'POST',
      data,
    })
  },
  ecomEvgExpenseDelApi(data = {}) {
    return request({
      url: '/ecom/evg/expense/del',
      method: 'POST',
      data,
    })
  },
  ecomEvgExpenseOaApplyApi(data = {}) {
    return request({
      url: '/oa/evg/expense/apply',
      method: 'POST',
      data,
    })
  },
})
